const pageTypes = {
  search_results: /^.+\/shop\/search\/(\w+\/)?(flights|hotels)?\?.*(id=\w+-\w+-\w+-\w+-\w+).+$/,
  product_details:
    /^.+((\/shop\/search\/(\w+\/)?(hotels|flights)\/)|(\/relax\/(\w+\/)?at\/)|(\/m\/fly\/search\/(\w+\/)?.+?\/details\/)).+$/,
  checkout_process: /^.+(\/cart\/checkout\/|\/shop\/search\/(\w+\/)?itinerary).+$/,
  post_booking: /^.+\/travel-itinerary.+$/,
  promotion: /^.+\/wl\/promotions\/(\w+)?\/?.*$/,
  about: /^.+\/wl\/about\/(\?\S+)?$/,
  index: /^.+\/shop\/search(\/\w+)?\/?.*$/,
  landing: /^.+(\/vacationpackages\/|\/wl\/)(\w+)?\/?.*$/,
  landing_base: /^.*hotels\.spirit\.com\/(\?\S+)?$/,
  landing_cars: /^.+\/rentalcars\/(\?\S+)?$/,
  landing_flights: /^.+\/flights\/(\?\S+)?$/,
  landing_hotels: /^.+\/hotels\/(\?\S+)?$/,
  search_results_cars: /^.+\/rental-?cars\/.+$/,
  search_results_flights: /^\S*\/m\/fly\/search\/(?:\w{3}-\w{3}-\d{8}\/).+$/,
  search_results_hotels: /^.+\/relax\/(in|near)\/.+$/,
  others: /^.+$/,
}

export const getType = (pageType) => {
  switch (pageType) {
    case 'index':
    case 'landing':
    case 'landing_base':
    case 'landing_cars':
    case 'landing_flights':
    case 'landing_hotels':
      return 'landing'
    case 'search_results':
    case 'search_results_cars':
    case 'search_results_flights':
    case 'search_results_hotels':
      return 'search'
    case 'product_details':
      return 'details'
    case 'checkout_process':
      return 'checkout'
    case 'post_booking':
      return 'book'
    case 'promotion':
      return 'promotion'
    case 'about':
      return 'about'
    default:
      return 'other'
  }
}

export const getPageType = (url) => {
  return Object.keys(pageTypes).find((type) => pageTypes[type].test(url))
}
